var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "url-export-control" },
    [
      _c(
        "md-menu",
        {
          ref: "urlMenu",
          staticClass: "url-export-menu",
          attrs: {
            "md-size": "4",
            "md-align-trigger": "md-align-trigger",
            "md-manual-toggle": _vm.isDraft
          }
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button md-raised btn",
              class: { "copy-trigger-disabled": _vm.isDraft },
              attrs: {
                "md-menu-trigger": "md-menu-trigger",
                title: "Copy video URL",
                "aria-busy": _vm.isDraftProcessing ? "true" : "false"
              },
              on: { click: _vm.handleTriggerClick }
            },
            [
              _vm.isDraftProcessing
                ? _c("stitch-loader", {
                    staticClass: "copy-trigger-disabled__loader",
                    attrs: { loading: true, size: 20 }
                  })
                : _c("md-icon", {
                    staticClass: "icon",
                    class: { "copy-trigger-disabled__icon": _vm.isDraft },
                    attrs: { "md-iconset": "fa fa-link" }
                  })
            ],
            1
          ),
          _c(
            "md-menu-content",
            [
              _c("md-subheader", [_vm._v("Copy URL for distribution")]),
              _vm.isMenuLoading
                ? _c(
                    "div",
                    { staticClass: "dist-menu-loader" },
                    [
                      _c("stitch-loader", {
                        attrs: { loading: true, size: 30 }
                      })
                    ],
                    1
                  )
                : _vm.menuDistributions && !_vm.menuDistributions.length
                ? _c("md-menu-item", [
                    _c("span", [_vm._v("No distributions found")])
                  ])
                : _vm.menuDistributions
                ? _vm._l(_vm.menuDistributions, function(dist) {
                    return _c(
                      "md-menu-item",
                      {
                        key: dist._id,
                        staticClass: "url-menu-item",
                        class: _vm.getMenuItemStateClass(dist),
                        on: {
                          click: function($event) {
                            return _vm.handleCopyClick(dist)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dist-name" }, [
                          _vm._v(_vm._s(dist.name))
                        ]),
                        _vm.shouldWarnDistribution(dist)
                          ? _c("md-icon", {
                              staticClass: "dist-state-icon",
                              attrs: {
                                "md-iconset": "fa fa-exclamation-triangle"
                              }
                            })
                          : _vm._e(),
                        _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                          _vm._v(_vm._s(_vm.buildVideoUrl(dist)))
                        ])
                      ],
                      1
                    )
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a46130ac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a46130ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/CopyVideoUrlMenu.vue
// module id = 915
// module chunks = 0